module.exports = __webpack_public_path__ + "img/card-with-tab-boxer.9f71df2f.webp";